import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";

import { TfSharedListPopperComponent } from "./components/tf-shared-list-popper/tf-shared-list-popper.component"
import { TfSharedListComponent } from './components/tf-shared-list/tf-shared-list.component';
import {
    TfSharedListNotLoggedInComponent
} from './components/tf-shared-list-not-logged-in/tf-shared-list-not-logged-in.component';

import { TfSharedListLoadingComponent } from "./components/tf-shared-list-loading/tf-shared-list-loading.component"


import { TfSharedListService } from './services/tf-shared-list.service';
import { TfUserDataModule } from "@app/modules/tf-user-data";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { TfSliderModule } from '@app/modules/tf-slider';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TfUserDataModule,
        NgbPopoverModule,
        TfSliderModule
    ],
    declarations: [
        TfSharedListPopperComponent,
        TfSharedListComponent,
        TfSharedListLoadingComponent,
        TfSharedListNotLoggedInComponent
    ],
    exports: [
        TfSharedListComponent
    ],
    providers: [
        TfSharedListService
    ]
})
export class TfSharedListModule {
}
